import React, { useRef } from 'react';
import '../styles/RoomList.css';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, ImageList, ImageListItem, ImageListItemBar } from '@mui/material';
import rooms from '../assets/rooms.json';
import 'animate.css';
import WOW from 'wow.js';

export default function Rooms() {
	const imgRefs = useRef([]);
	const textRefs = useRef([]);
	const [visibleItems, setVisibleItems] = useState({});

	useEffect(() => {
		const observers = [];

		// Create observers for each item
		rooms.forEach((_, idx) => {
			// Observer for image
			if (imgRefs.current[idx]) {
				const imgObserver = new IntersectionObserver(
					([entry]) => {
						if (entry.isIntersecting) {
							setVisibleItems((prev) => ({
								...prev,
								[`img-${idx}`]: true,
							}));
							imgObserver.disconnect();
						}
					},
					{ threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
				);

				imgObserver.observe(imgRefs.current[idx]);
				observers.push(imgObserver);
			}

			// Observer for text
			if (textRefs.current[idx]) {
				const textObserver = new IntersectionObserver(
					([entry]) => {
						if (entry.isIntersecting) {
							setVisibleItems((prev) => ({
								...prev,
								[`text-${idx}`]: true,
							}));
							textObserver.disconnect();
						}
					},
					{ threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
				);

				textObserver.observe(textRefs.current[idx]);
				observers.push(textObserver);
			}
		});

		return () => {
			observers.forEach((observer) => observer.disconnect());
		};
	}, [rooms]);

	useEffect(() => {
		new WOW().init();
	}, []);

	useEffect(() => {
		const booking = document.querySelector('.div');
		function handleScroll() {
			const scrollY = window.scrollY;
			const maxScroll = 2000;
			const ratio = Math.min(scrollY / maxScroll, 1);
			const base = 223;
			const max = 255;
			const value = Math.round(base + (max - base) * ratio);
			if (booking) {
				booking.style.backgroundColor = `rgba(${value}, ${value}, ${value}, 0.5)`;
				booking.style.willChange = 'background-color';
			}
		}
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	return (
		<div className="div">
			<div className="page-banner-wrapper">
				<h2 className="page-banner-title">Rooms</h2>
				<img
					className="page-banner"
					src="https://thehighpoint.s3.ca-central-1.amazonaws.com/banner-quadra.jpg"
					alt="Rooms"
				/>
			</div>
			<Box className="room-list" container>
				<ImageList
					className="image-list"
					cols={1}
					sx={{
						p: { sm: '32px 0 !important' },
					}}
				>
					{rooms.map((room, idx) => (
						<React.Fragment key={room.id}>
							{idx !== 0 && <hr className="divider" />}
							<ImageListItem className="image-list-item">
								<Box className="product-item">
									<div
										ref={(el) =>
											(imgRefs.current[idx] = el)
										}
										className={`product-img-container ${visibleItems[`img-${idx}`] ? 'animate__animated animate__fadeInUp' : ''}`}
									>
										<Link to={`/room/${room.name}`}>
											<img
												src={room.img}
												alt={room.eng_name}
												loading="lazy"
											/>
										</Link>
									</div>
									<Link
										to={`/room/${room.name}`}
										className="product-link"
									>
										<ImageListItemBar
											ref={(el) =>
												(textRefs.current[idx] = el)
											}
											className={`product-item-bar ${visibleItems[`text-${idx}`] ? 'animate__animated animate__fadeInUp' : ''}`}
											title={<span>{room.eng_name}</span>}
											subtitle={room.description}
											position="below"
											sx={{
												'.MuiImageListItemBar-titleWrap':
													{
														p: 0,
													},
												'.MuiImageListItemBar-title': {
													color: '#001b42',
													marginBottom: {
														xs: '10px',
														xl: '20px',
													},
													fontSize: {
														xs: '28px',
														xl: '36px',
													},
													lineHeight: {
														xs: '36px',
														xl: '40px',
													},
													textAlign: {
														xs: 'center',
														md: 'left',
													},
													fontWeight: 'bold',
												},
												'.MuiImageListItemBar-subtitle':
													{
														color: '#001b42',
														fontSize: {
															xs: '16px',
															sm: '18px',
															md: '16px',
															lg: '18px',
															xl: '20px',
														},
														textAlign: 'left',
														textWrap: 'wrap',
														lineHeight: {
															xs: '1.25',
															xl: '1.5',
														},
													},
												'.MuiImageListItemBar-titleWrap:active':
													{
														transform:
															'translateY(1.5px)',
													},
											}}
										/>
									</Link>
								</Box>
							</ImageListItem>
						</React.Fragment>
					))}
				</ImageList>
			</Box>
		</div>
	);
}
